import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

function About({ onNext }) {
  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftTypography variant="h4" fontWeight="bold">
          UDS Private Network Router
        </SoftTypography>
        <SoftTypography variant="body1" fontWeight="regular" color="text">
          Sichere und leistungsstarke Netzwerkverbindungen für Ihre Cloud-Infrastruktur.
          Verbinden Sie Ihre privaten und öffentlichen Cloud-Ressourcen mit maximaler 
          Sicherheit und Kontrolle.
        </SoftTypography>
      </SoftBox>

      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Netzwerk-Features
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Bandbreiten von 100 Mbit/s bis 1 Gbit/s <br />
              - Bis zu 100 VPN-Tunnel <br />
              - VXLAN & VLAN Support <br />
              - QoS (Quality of Service) <br />
              - BGP Routing Support
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Sicherheit
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Integrierte oder verwaltete Firewall <br />
              - IPSec & SSL VPN <br />
              - DDoS-Schutz <br />
              - Network Segregation <br />
              - Echtzeit-Monitoring
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              High Availability
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Redundante Hardware-Option <br />
              - Automatisches Failover <br />
              - Load Balancing <br />
              - 99,99% Verfügbarkeit bei HA-Setup <br />
              - Multi-Zone Deployment möglich
            </SoftTypography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Management
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              - Intuitives Web-Interface <br />
              - REST API Zugriff <br />
              - SNMP Monitoring <br />
              - Detaillierte Verkehrsanalysen <br />
              - 24/7 Support
            </SoftTypography>
          </Grid>
        </Grid>
      </SoftBox>

      <SoftBox mt={4} textAlign="center">
        <SoftButton color="info" onClick={onNext}>
          Router jetzt konfigurieren
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
}

About.propTypes = {
  onNext: PropTypes.func.isRequired,
};

export default About;